export const environment = {
  production: true,
  version: '25.01.4',
  baseApiUrl: window.location.origin,
  securedApis: [
    'https://localhost:5004',
    'https://localhost:5002',
    'https://localhost:5001',
    'https://decr-portal-test.azurewebsites.net',
    'https://decr-portal.azurewebsites.net',
    'https://decr-wallet.azurewebsites.net/',
    'https://decr-auth.azurewebsites.net/',
    'https://ecred-portal.azurewebsites.net',
    'https://ecred-wallet.azurewebsites.net/',
    'https://ecred-auth.azurewebsites.net/',
    'https://ecred-portal-test.azurewebsites.net',
    'https://ecred-wallet-test.azurewebsites.net/',
    'https://ecred-auth-test.azurewebsites.net/',
    'https://ecs-portal-test.azurewebsites.net',
    'https://ecs-wallet-test.azurewebsites.net/',
    'https://ecs-auth-test.azurewebsites.net/',
    'https://portal.ecredits.com',
    'https://wallet.ecredits.com/',
    'https://auth.ecredits.com/',
  ],
  googleStoreUrl: 'https://play.google.com/store/apps/details?id=com.ecredits.wallet',
  appleStoreUrl: 'https://apps.apple.com/ch/app/ecredits-wallet/id1542789150',
  // theme START
  adminRoot: '/',
  defaultMenuType: 'menu-default',
  subHiddenBreakpoint: 1440,
  menuHiddenBreakpoint: 768,
  themeColorStorageKey: 'vien-themecolor',
  isMultiColorActive: false,
  defaultColor: 'ecredits',
  isDarkSwitchActive: false,
  defaultDirection: 'ltr',
  themeRadiusStorageKey: 'vien-themeradius',
  isAuthGuardActive: false,
  // THEME END
  defaultConsumerLogoId: '11111111-1111-1111-1111-111111111111',
  defaultBusinessLogoId: '22222222-2222-2222-2222-222222222222',
  defaultConsumerName: 'Consumer',
  cashbackWorldName: 'eCashback contract',
  maxImageSize: 2,
  regex: {
    website: '^(https?://www\\.|https?://|www\\.)[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(/.*)?$',
    email: '^[\\S]+@[0-9a-zA-Z_-]{2,}?(\\.[0-9a-zA-Z_]{2,}?)*(\\.[a-zA-Z]{2,}){1,2}$',
    tax: '^[a-zA-Z0-9]*$',
    phone: '^[0-9+()/]*$',
    amountRegex: '^[0-9]*(.[0-9]{1,8})?$',
  },
  noOfDashoboardTransactions: 15,
  noOfTransactionsForScrolling: 15,
  paymentReferenceValidation: {
    minLength: 2,
    maxLength: 64,
  },

  minimumAmount: 0.01,
  qrCodeWidth: {
    sm: 256,
    md: 256,
  },
  timeToSleep: 5,
  invitationMessageMaxLength: 400,
  hideWebWidget: false,
  maxTxExport: 1000,
  sceMembershipFormUrl: 'https://forms.office.com/r/mjfYnYh8zF',
  ambassadorTrainingPage: 'pages/ambassadors',
  resolveOtherLanguagesToEnglish: 'false',
};
